import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

import noGroupsSVG from '../../../../../static/no-groups.svg';
import {
  Container,
  NoGroupsIcon,
  Title,
  Text,
} from './NoGroupsPlaceholder.styled';

const NoGroupsPlaceholder = ({ isEducator }) => {
  const baseText =
    'Looks like this space currently has no sets or groups setup.';
  const educatorText = isEducator ? 'Start by tapping ‘New set’ above.' : '';

  const ref = useRef(null);

  useEffect(() => {
    ref.current && ref.current.focus && ref.current.focus();
  }, [ref]);

  return (
    <Container>
      <NoGroupsIcon src={noGroupsSVG} />
      <Title>Nothing to see!</Title>
      <Text innerRef={ref} tabIndex={-1}>
        {baseText}
        <br />
        {educatorText}
      </Text>
    </Container>
  );
};

NoGroupsPlaceholder.propTypes = {
  isEducator: PropTypes.bool.isRequired,
};

export default NoGroupsPlaceholder;
